/**
 * @param props.path - Absolute or relative path
 *
 * this is just a container for the props
 * actually component would be created inside RouterTabs
 */
export function RouteTab(props) {
    return null;
}
